import React from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';

import history from '../../utils/history';

function WarfareModal({ open, closeModal }) {
  const handleOnClose = () => {
    if (closeModal) {
      closeModal();
    }
  };

  const handleManageSubscription = () => {
    history.push('/app/manage-subscription');
  };

  return (
    <div>
      <Modal
        isOpen={open}
        className="practice-exam-popup warfare-modal modal-dialog-centered"
      >
        <ModalHeader
          tag="div"
          toggle={handleOnClose}
          className="warfare-header"
        >
          <h4 className="mt-2 title">
            That feature is only available for In Rate Study
          </h4>
        </ModalHeader>
        <ModalBody className="margin0">
          <div className="warfare-body">
            <span className="mb-4 description">
              This feature is only avaiable for in-rate study. You can update
              your subscription to access this feature.
              {/* , or you can study by
              Quals & Certs */}
            </span>
            {/* <Button
              color="error"
              size="xs"
              block
              onClick={() => {
                history.push('/app/study/quals-and-certs');
              }}
              className="mb-2"
            >
              Study By Quals & Certs
            </Button> */}
            <Button
              color="primary"
              size="xs"
              block
              onClick={handleManageSubscription}
            >
              MANAGE MY SUBSCRIPTION
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default WarfareModal;
